module.exports = __webpack_public_path__ + "bdddba78b8184b60869c552a2642249c.pdf";